import { File } from '@clearkit/icons';

import { BillingPaymentPage } from '~/components/billing/BillingPaymentPage';
import { PageLayout } from '~/components/PageLayout';

export const PageGeneralBilling = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <File />
      </PageLayout.Tile>
      <PageLayout.Heading>Billing & Invoices</PageLayout.Heading>
      <PageLayout.SubHeading>
        Manage your billing information
      </PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <BillingPaymentPage />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
